import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';

import api, { urlParamCharacter } from '../services/api';

class CategoriesLayout extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
    };
  }

  componentDidMount() {
    const { path } = this.props;

    api.get(`${path}_categories${urlParamCharacter}per_page=100&orderby=menu_order&order=asc`)
      .then((response) => {
        this.setState({ categories: response.data });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      });
  }

  render() {
    const {
      path,
      location,
      header,
      children,
    } = this.props;
    const { categories } = this.state;
    const background = location.state && location.state.background;

    return (
      <>
        {!background && (
          <>
            {header}
            <div className="CategoriesLayout__background">
              <nav
                className="CategoriesLayout__navigation"
                aria-label="Clients"
              >
                <ul className="CategoriesLayout__list">
                  {categories.map((category) => (
                    <li
                      className="CategoriesLayout__list-item"
                      key={category.title.rendered}
                    >
                      <NavLink
                        className="CategoriesLayout__link"
                        to={`${path}/${category.slug}`}
                      >
                        <span
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{ __html: category.title.rendered }}
                        />
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </>
        )}
        {children}
      </>
    );
  }
}

CategoriesLayout.propTypes = {
  path: PropTypes.string.isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      background: PropTypes.object.isRequired,
    }),
  }).isRequired,
  header: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]).isRequired,
};

CategoriesLayout.defaultProps = {
  header: null,
};

export default withRouter(CategoriesLayout);
